import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from '../../data/ui';

export default makeStyles(
  (theme) => ({
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      color: COLORS.primary.light,
      '&$completed': {
        color: COLORS.primary.medium,
      },
      '&$active': {
        color: theme.palette.primary.main,
      },
      '&$error': {
        color: theme.palette.error.main,
      },
    },

    /* Styles applied to the SVG text element. */
    text: {
      fill: theme.palette.common.white,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: theme.typography.fontWeightBold,
    },

    /* Pseudo-class applied to the root element if `active={true}`. */
    active: {},

    /* Pseudo-class applied to the root element if `completed={true}`. */
    completed: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
  }),
  { name: 'WizardStepperIcon' }
);
